import {ResourceType} from "../types";
import {Create, SimpleForm} from "react-admin";
import {inputFieldForColumn} from "./inputFieldForColumn";
import React from "react";

export const CreateComponentFromResource = (resource: ResourceType) => {
  const Component = () => (
    <Create>
      <SimpleForm>
        {resource.columns.map((column) => inputFieldForColumn(column, resource))}
      </SimpleForm>
    </Create>
  );

  Component.displayName = `${resource.pluralized_name.replaceAll(' ', '')}Create`;

  return Component;
};